import FacebookConfiguration from './FacebookConfiguration';

export default FacebookConfiguration;
